import {BaseApiService} from "../../../StarterKit/Service/BaseApiService";

export default class ApiFilter extends BaseApiService {

    async listFromModel() {
        this.setGetMethod();
        this.setSecureByUser();
        this.setApiRoute(sessionStorage['language'] + "/list_filters");
        return await this.callApi();
    }

}